/**
 * Returns true if the user should see an app.
 * - userGroups === null means filtering is disabled (show everything)
 * - empty requiredGroups means the app is visible to everyone
 * - otherwise, at least one requiredGroup must be in userGroups
 */
export function hasAccess(userGroups, requiredGroups) {
  if (userGroups === null) return true;
  if (!requiredGroups || requiredGroups.length === 0) return true;
  return requiredGroups.some((g) => userGroups.includes(g));
}
